import { formatStudyDuration } from '@/core/helpers/educationHelpers'
import { camelCaseToSnakeCase } from '@/core/helpers/dataHelpers'

export const computeEducation = educationArr =>
  educationArr.map(education => {
    const { start_year: startYear, graduation_year: graduationYear, university, ...rest } = education
    return {
      ...rest,
      university,
      startYear,
      graduationYear,
    }
  })

export const buildEducation = ({ id, university, degree, startYear, graduationYear, description }) => ({
  id,
  institution: university,
  degree,
  studyDuration: formatStudyDuration(startYear, graduationYear, 'MMMM yyyy'),
  isMissingEducationInfo: Boolean(!startYear || !graduationYear || !university || !degree),
  description,
})

export const sortEducation = (itemA, itemB) => {
  if (itemA.graduationYear > itemB.graduationYear) return -1
  if (itemA.graduationYear < itemB.graduationYear) return 1
  return 0
}

export const formatComprehensiveLocation = camelCasedLocation => {
  const snakeCasedLocation = camelCaseToSnakeCase(camelCasedLocation)

  snakeCasedLocation.country_iso2_code = snakeCasedLocation.country_iso2_code?.toLowerCase()
  snakeCasedLocation.location_category = snakeCasedLocation.location_category?.toLowerCase()
  snakeCasedLocation.type = snakeCasedLocation.type?.toLowerCase()

  return snakeCasedLocation
}
